/**
 * Custom hook for editing organization-level feature flags
 */

import { useAppDispatch } from '@/store';
import { setSelectedFlag, setSelectedOrganizationId, fetchOrganizationFlags } from '@/store/slices/admin/featureFlagsSlice';
import { FeatureFlagAttributes } from '@/types/admin/featureFlags';
import { getOrganizationId } from '../utils/featureFlagsUtils';

export const useOrganizationFlagsEditor = (
  onSelectRow: (flag: FeatureFlagAttributes, isOrgView: boolean) => void
) => {
  const dispatch = useAppDispatch();

  const handleEditOrganization = async (flags: FeatureFlagAttributes[]) => {

    const orgId = getOrganizationId(flags[0]);
    if (!orgId) {
      console.error('No organization ID found in flag:', flags[0]);
      return;
    }

    try {
      const result = await dispatch(fetchOrganizationFlags(orgId)).unwrap();
      const orgFlag: FeatureFlagAttributes = {
        id: orgId,
        organization_id: orgId,
        organizationName: flags[0].organizationName,
        flags: result.flags || {},
        // Don't set updatedAt/createdAt - they're optional and cause Redux serialization warnings
      };

      dispatch(setSelectedOrganizationId(orgId));
      dispatch(setSelectedFlag(orgFlag));
      onSelectRow(orgFlag, true);
    } catch (error) {
      console.error('Failed to fetch organization flags:', error);
      // Optionally show an alert to the user
    }
  };

  return { handleEditOrganization };
};

